(function () {
  // Tag => message mapping (add as many as you want)
  const TAG_MESSAGES = {
	"3socksfor30": "Buy 3 Socks for $30",
	  "3teesfour150": "Buy 3 Tees for $150",
	  "3isantiteesfour150": "Buy 3 Tees for $150",
	};

  function normalize(tag) {
	return String(tag || "").trim().toLowerCase();
  }

  function getMessageFromTags(tags) {
	for (const t of tags) {
	  const key = normalize(t);
	  if (TAG_MESSAGES[key]) return TAG_MESSAGES[key];
	}
	return "";
  }

  function applyMessages(root = document) {
	const nodes = root.querySelectorAll(".tag-promo-message[data-product-tags]");
	nodes.forEach((el) => {
	  const raw = el.getAttribute("data-product-tags") || "";
	  const tags = raw.split(",").map(normalize).filter(Boolean);

	  const msg = getMessageFromTags(tags);

	  if (msg) {
		el.textContent = msg;
		el.style.display = ""; // show
	  } else {
		el.textContent = "";
		el.style.display = "none"; // hide when no match
	  }
	});
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", () => applyMessages());

  // If your theme updates sections via AJAX (filters, infinite scroll, quick add, etc.)
  document.addEventListener("shopify:section:load", (e) => applyMessages(e.target));

  // Optional: if you use facet filtering that re-renders product grid without section reload,
  // you may need to call applyMessages() after the grid updates.
  // Many Dawn setups re-render sections (so shopify:section:load is enough).
})();
